const Videos = function() {
    return {
        initHandlers: function() {
            $('.video-overlay-trigger').off().click(function() {
                window.location.hash = $(this).data('vid');
                Ajax.getVideoModal($(this).data('vid'), function(res) {
                    if (res.success == 'ok' && res.html) {
                        $('body').addClass('video-overlay-on');
                        $('#video-modal-container').html(res.html);
                        Videos.initHandlers();
                    }
                });
            });
        },
        init: function(hash_on_close = '') {
            Videos.initHandlers();
            if (Generic.mobile) {
                $('.carousel--video').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '60px',
                    arrows: false
                });
            } else {
                $('.carousel--video').slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    autoplay: false
                });
            }
            if (window.location.hash &&
                window.location.hash.substring(1)) {
                Ajax.getVideoModal(window.location.hash.substring(1), function(res) {
                    if (res.success == 'ok' && res.html) {
                        $('body').addClass('video-overlay-on');
                        $('#video-modal-container').html(res.html);
                        Videos.initHandlers();
                    }
                });
            }
            $('.video-overlay__close').click(function() {
                window.location.hash = hash_on_close;
                $('#video-modal-container').empty();
                $('.page').removeClass('video-overlay-on');
            });
            $(document).on('keydown', function(event) {
                if (event.key == 'Escape') {
                    window.location.hash = '';
                    $('#video-modal-container').empty();
                    $('.page').removeClass('video-overlay-on');
                }
            });
        }
    };
}();

//# sourceMappingURL=videos.js.map
